import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const maniaDeChurrascoTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#b9222c',
    },
    secondary: {
      main: '#1f1f1f',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#b9222c',
    },
  },
};
